import React from 'react';
import {
    OverlayDrawer,
    DrawerHeaderTitle,
    DrawerBody,
    Button,
    makeStyles,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';

export interface AppDrawerProps {
    open: boolean;
    onClose: () => void;
    title?: string;
    size?: 'small' | 'medium' | 'large' | 'full';
    position?: 'start' | 'end';
    children: React.ReactNode;
}

const useStyles = makeStyles({
    header: {
        position: 'absolute',
        right: '0',
        top: '0',
        padding: '16px',
        zIndex: 10,
    },
    body: {
        paddingBottom: '32px',
    },
});

const AppDrawer: React.FC<AppDrawerProps> = ({
    open,
    onClose,
    title,
    size = 'large',
    position = 'end',
    children,
}) => {
    const classes = useStyles();

    return (
        <OverlayDrawer
            size={size}
            open={open}
            position={position}
            onOpenChange={(_event, data) => {
                if (!data.open) {
                    onClose();
                }
            }}
        >
            <DrawerHeaderTitle
                className={classes.header}
                action={
                    <Button
                        appearance="subtle"
                        aria-label="Close"
                        icon={<DismissRegular />}
                        onClick={onClose}
                    />
                }
            >
                {title}
            </DrawerHeaderTitle>
            <DrawerBody className={classes.body}>{children}</DrawerBody>
        </OverlayDrawer>
    );
};

export default AppDrawer;
